import UsuarioDetailPage from './UsuarioDetailPage';

export default UsuarioDetailPage;
